module.exports = __webpack_public_path__ + "images/gavdos/routes/HER-GVD-HER-inactive@2x.png";